// src/reducers/galleryReducer.js
import {
  FETCH_GALLERY_REQUEST,
  FETCH_GALLERY_SUCCESS,
  FETCH_GALLERY_FAILURE,
  CREATE_ARTWORK_REQUEST,
  CREATE_ARTWORK_SUCCESS,
  CREATE_ARTWORK_FAILURE,
  UPDATE_ARTWORK_REQUEST,
  UPDATE_ARTWORK_SUCCESS,
  UPDATE_ARTWORK_FAILURE,
  DELETE_ARTWORK_REQUEST,
  DELETE_ARTWORK_SUCCESS,
  DELETE_ARTWORK_FAILURE,
  SELECT_ARTWORK,
  CLEAR_SELECTED_ARTWORK,
} from "../actions/types";

const initialState = {
  artworks: [],
  selectedArtwork: null,
  loading: false,
  error: null,
};

const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GALLERY_REQUEST:
    case CREATE_ARTWORK_REQUEST:
      return { ...state, loading: true, error: null };

    case UPDATE_ARTWORK_REQUEST:
    case DELETE_ARTWORK_REQUEST:
      return { ...state, error: null };

    case FETCH_GALLERY_SUCCESS:
      return { ...state, loading: false, artworks: action.payload };

    case CREATE_ARTWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        artworks: [action.payload, ...state.artworks],
      };

    case UPDATE_ARTWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        artworks: state.artworks.map((a) =>
          a.entityId === action.payload.entityId ? action.payload : a
        ),
        selectedArtwork:
          state.selectedArtwork?.entityId === action.payload.entityId
            ? action.payload
            : state.selectedArtwork,
      };

    case DELETE_ARTWORK_SUCCESS:
      return {
        ...state,
        loading: false,
        artworks: state.artworks.filter((a) => a.entityId !== action.payload),
        selectedArtwork:
          state.selectedArtwork?.entityId === action.payload
            ? null
            : state.selectedArtwork,
      };

    case FETCH_GALLERY_FAILURE:
    case CREATE_ARTWORK_FAILURE:
    case UPDATE_ARTWORK_FAILURE:
    case DELETE_ARTWORK_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SELECT_ARTWORK:
      return { ...state, selectedArtwork: action.payload };

    case CLEAR_SELECTED_ARTWORK:
      return { ...state, selectedArtwork: null };

    default:
      return state;
  }
};

export default galleryReducer;
